import React from 'react';
import styles from './icon-list.module.scss';


class IconList extends React.Component {
  getClassName () {
    const columnsName = this.props.columns ? `iconList--${this.props.columns}` : ``;
    return `${styles.iconList} ${columnsName}`;
  }
  render () {
    return (
    <div className={'container panel'}>
      <h2 className={styles.title}>{this.props.title}</h2>
      <ul className={this.getClassName()}>
        {this.props.children}
      </ul>
    </div>
    )
  }
}

export default IconList;



// WEBPACK FOOTER //
// ./src/components/IconList/index.js